import React from 'react'
import large6 from '../../assets/images/services/large/06.jpg'
import HeroSection4 from '../../Components/heroSection/HeroSection4'
import BlogSection2 from '../../Components/blogSection/BlogSection2'

const BusinessStrategy = () => {
  return (
    <>
      <HeroSection4 name={"UI/UX Experience"} name2={"Home"} />
      <BlogSection2 bgImage={large6} selected={6} />
    </>
  )
}

export default BusinessStrategy